module.exports = __webpack_public_path__ + "img/ring_y_l_1_1@3x.d96df362.png";